import React from 'react'

/**
 * Reading patterns for financial detail modals — bookings, wallet, payouts.
 *
 * StatChip is for a run of figures that add up to something: gross, discount,
 * fees, net. Tone carries the sign so a deduction reads as one at a glance.
 */
export const StatChip = ({ label, value, tone }) => (
  <span
    className={`app-modal__stat-chip ${
      tone ? `app-modal__stat-chip--${tone}` : ''
    }`.trim()}
  >
    {label}
    <b>
      {tone === 'negative' ? '- ' : ''}
      {value}
    </b>
  </span>
)

export const StatChips = ({ children }) => (
  <div className='app-modal__chips-stat'>{children}</div>
)

/**
 * A single labelled figure with its working shown underneath. `hints` explain
 * how the number was reached — the rate used, whether a discount was applied —
 * which is the difference between an auditable number and a mysterious one.
 */
export const AmountRow = ({
  label,
  value,
  hints = [],
  negative = false,
  // The figure the run adds up to. One per run, or the emphasis stops meaning
  // anything.
  strong = false,
}) => (
  <div className={`app-modal__kv ${strong ? 'app-modal__kv--strong' : ''}`.trim()}>
    <div>
      <div className='app-modal__kv-label'>{label}</div>
      {hints.filter(Boolean).map((hint, index) => (
        <div key={index} className='app-modal__kv-hint'>
          {hint}
        </div>
      ))}
    </div>
    <div
      className={`app-modal__kv-value ${
        negative ? 'app-modal__kv-value--negative' : ''
      }`.trim()}
    >
      {negative ? '- ' : ''}
      {value}
    </div>
  </div>
)

/** Segmented progress bar — proportions of a whole, each with its own meaning. */
export const Meter = ({ segments = [], title }) => {
  const total = segments.reduce((sum, s) => sum + Math.max(0, s.value), 0) || 1
  return (
    <div className='app-modal__meter' title={title}>
      {segments.map((segment, index) => (
        <div
          key={index}
          style={{
            width: `${(Math.max(0, segment.value) / total) * 100}%`,
            background: segment.color,
          }}
        />
      ))}
    </div>
  )
}
